var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"o-grid o-grid--no-gutter"},[_c('div',{staticClass:"o-grid__cell"},[_c('h2',[_vm._v(_vm._s(_vm.$t('admin.fair.overview.section.main.title')))])]),_c('div',{staticClass:"o-grid__cell top-buttons"},[_c('bos-button',{on:{"click":_vm.newFair}},[_vm._v("Neue Messe")])],1)])]),_c('section',[_c('h3',[_vm._v(_vm._s(_vm.$t('admin.fair.overview.section.now.title')))]),_c('bos-overview-table',{attrs:{"data":_vm.openFairs,"columns":[
        {
          key: 'displayNameDe',
          name: 'Name'
        }
      ],"deleteTitle":"Messe löschen","deleteText":obj =>
          'Soll die Messe <b>"' +
          obj.displayNameDe +
          '"</b> wirklich gelöscht werden?',"onEdit":_vm.editFair,"onDelete":_vm.deleteFair}})],1),_c('section')])
}
var staticRenderFns = []

export { render, staticRenderFns }